/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    Header: 100,
    Modal: 1000,
    Escape: 10000, // Make sure this is always the highest value.
};
